import {ViewTypeVo} from '../../common/shared/api/karina/vo/enums/ViewTypeVo.enum';
import {BannerViewType} from '../generated/types';

export function createBannerViewType(
  bannerViewType: ViewTypeVo
): BannerViewType {
  return map[bannerViewType];
}

const map: {
  [key in ViewTypeVo]: BannerViewType;
} = {
  [ViewTypeVo.SeriesCardView]: BannerViewType.Unknown,
  [ViewTypeVo.SingleCardView]: BannerViewType.Unknown,
  [ViewTypeVo.SeriesPosterView]: BannerViewType.Unknown,
  [ViewTypeVo.SinglePosterView]: BannerViewType.Unknown,
  [ViewTypeVo.SeriesCleanView]: BannerViewType.Unknown,
  [ViewTypeVo.SingleCleanView]: BannerViewType.Unknown,
  [ViewTypeVo.StrategyView]: BannerViewType.Unknown,
  [ViewTypeVo.SquareView]: BannerViewType.Square,
  [ViewTypeVo.RectangleView]: BannerViewType.Rectangle,
  [ViewTypeVo.SeriesListView]: BannerViewType.Unknown,
  [ViewTypeVo.SingleListView]: BannerViewType.Unknown,
  [ViewTypeVo.BannerCardView]: BannerViewType.Unknown,
  [ViewTypeVo.BannerPromotionView]: BannerViewType.Unknown,
  [ViewTypeVo.BannerLineView]: BannerViewType.Unknown,
};
